var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVideo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 17,
  fill: "none",
  viewBox: "0 0 17 17"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#0E0F0F",
  clipPath: "url(#istock-video-icon)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.943 16.692H2.75A2.753 2.753 0 0 1 0 13.942V2.75A2.753 2.753 0 0 1 2.75 0h11.193a2.753 2.753 0 0 1 2.75 2.75v11.192a2.753 2.753 0 0 1-2.75 2.75M2.75 1.5c-.69 0-1.25.56-1.25 1.25v11.192c0 .69.56 1.25 1.25 1.25h11.193c.69 0 1.25-.56 1.25-1.25V2.75c0-.69-.56-1.25-1.25-1.25z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m10.28 8.996-3.117 1.8a.75.75 0 0 1-1.125-.65v-3.6a.75.75 0 0 1 1.125-.649l3.117 1.8a.75.75 0 0 1 0 1.299"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "istock-video-icon"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16.692v16.692H0z"
})))));
export default SvgVideo;